import React, { useEffect, useState } from 'react'
import "./CSS/TesisSec.css"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Store from '../Store/Store';
import { setTesis } from '../Action/Action';
import axiosInstance from '../services/axiosConfig';

const TesisSec = (props) => {
  const history = useHistory();


  const [groups, Set_groups] = useState([]);

  const [companies, Set_companies] = useState([]);
  const [active_companies, Set_active_companies] = useState([]);

  const [tesisSec, Set_tesisSec] = useState(true)


  useEffect(() => {
    const componentDidMount = async () => {

      console.log("🔥🔥🔥 TesisSec Component Loaded - NEW VERSION");

      // 🔥 TesisSec sayfasına geldiğinde sessionStorage'daki TEMPCOM'u temizle
      // Böylece App.js authenticated routes'a geçmeye çalışmaz
      console.log("🔥 TesisSec: Clearing TEMPCOM from sessionStorage to prevent auth redirect");
      sessionStorage.removeItem("TEMPCOM");
      sessionStorage.removeItem("ucer_id");

      // State'leri de sıfırla
      Set_tesisSec(true);
      Set_active_companies([]);
      setSelectedOptionTesis("Tesis Seçin");
      setIsOpenTesis(false);

      const req_ = await axiosInstance.get("/tags/GetCompanies");
      const response = req_.data;
      console.warn(response, "respoınse company")

      var newData = [];
      var newData2 = [];

      if (req_.status === 200 && response.length > 0) {
        response.forEach(a => {
          if (a.groupName && newData.indexOf(a.groupName) < 0 && a.groupName !== "RMMS") newData.push(a.groupName)
          newData2.push(a)

        })

      }

      Set_companies(newData2)

      Set_groups(newData)


    }

    componentDidMount()
  }, [])

  const findActiveCompanies = (groupName) => {
    if (companies.length > 0) {
      const newList = companies.filter(i => {
        return i.groupName === groupName
      })

      Set_active_companies(newList)
    }
  }

  const [isOpenTesis, setIsOpenTesis] = useState(false);
  const [selectedOptionTesis, setSelectedOptionTesis] = useState("Tesis Seçin");

  const toggleDropdownTesis = () => setIsOpenTesis(!isOpenTesis);

  const handleOptionClickTesis = (option) => {
    setSelectedOptionTesis(option);
    setIsOpenTesis(false);
  };


  return (
    <div
      style={{

      }}
      className="main-d-vrf tesissection"
    >
      <section style={{ width: "100%", height: "100%" }}>
        <div
          style={{
            width: "95%",
            height: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            padding: "0 4% ",
          }}
          className="btn-group"
        >
          {tesisSec && (
            <div style={{ width: "30%", position: "relative" }} className="select-box tesis-select">
              <div className="select-box-header" onClick={toggleDropdownTesis}>
                {selectedOptionTesis}
                <span className={`arrow ${isOpenTesis ? 'open' : ''}`}>▼</span>
              </div>
              {isOpenTesis && (
                <ul className="select-box-dropdown" style={{ position: "absolute", width: "100%", top: "100%", left: 0, right: 0, zIndex: 1000, backgroundColor: "#fff", border: "1px solid #ccc", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
                  {groups.length > 0 && groups.map((option, index) => (
                    <li
                      id={index + 1}
                      key={index}
                      onClick={() => {
                        findActiveCompanies(option);
                        Set_tesisSec(false);
                        handleOptionClickTesis(option);
                      }}
                      className="select-box-option"
                      style={{ padding: "8px 12px", cursor: "pointer", listStyle: "none" }}
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}

          {!tesisSec && active_companies.length > 0 && < div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "80%" }}>

            <div style={{ width: "80%", display: "flex", alignItems: "center", justifyContent: "right", margin: "3% 0" }}> <button onClick={() => {
              Set_active_companies([]);
              Set_tesisSec(true)
            }} className='again-select-tesis'>Tesis Seç <i className="fa fa-arrow-left"></i></button></div>

            <div className="grid_system_tesis">
              {active_companies.map((item, index) => {
                console.log(item);
                return <button id={item.companyID}
                  style={{
                    backgroundColor: "rgb(237, 188, 69)",
                    color: "rgb(45, 45, 45)",
                    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "3px solid rgb(67, 51, 22)",
                    borderRadius: "16px",
                    padding: "10px",
                    fontSize: "19px",
                    fontWeight: "600",
                    cursor: "pointer",
                    outline: "none",
                    appearance: "none",
                    userSelect: "none",
                    maxHeight: "120px",
                    width: "240px",
                    transition: "0.3s",

                  }}
                  onClick={async () => {
                    // Seçilen company ID'yi string olarak al
                    const selectedCompanyId = String(item.companyID);
                    const companyIdNum = parseInt(selectedCompanyId);

                    console.log("✅ TesisSec: Seçilen Tesis =", item.companyName, "ID =", selectedCompanyId);

                    // 🔥 Auth bilgilerini sessionStorage'dan oku
                    const userId = sessionStorage.getItem("user_id");
                    const username = sessionStorage.getItem("username");
                    const userEmail = sessionStorage.getItem("user_email");
                    const userCompanyId = sessionStorage.getItem("user_companyId");
                    const jwtToken = sessionStorage.getItem("jwt_token");

                    // 🔥 CompanyId > 2 için ÖNCE SCADA Homepage'i bul, sonra direkt o URL'i aç
                    if (companyIdNum > 2) {
                      try {
                        const response = await axiosInstance.get(`/scada/pages/homepage/${companyIdNum}`);
                        if (response.data && response.data.pageId) {
                          // Direkt SCADA sayfasını aç
                          const scadaUrl = `/axisPreview/${response.data.pageId}?companyId=${selectedCompanyId}&user_id=${userId}&username=${encodeURIComponent(username)}&user_email=${encodeURIComponent(userEmail)}&user_companyId=${userCompanyId}&token=${encodeURIComponent(jwtToken || '')}`;
                          console.log("✅ TesisSec: Opening SCADA Homepage:", scadaUrl);
                          window.open(scadaUrl, "_blank");

                          // State'i sıfırla
                          setTimeout(() => {
                            Set_active_companies([]);
                            Set_tesisSec(true);
                            setSelectedOptionTesis("Tesis Seçin");
                            setIsOpenTesis(false);
                          }, 500);
                          return;
                        }
                      } catch (err) {
                        console.log("⚠️ TesisSec: Could not fetch SCADA homepage:", err);
                      }
                    }

                    // 🔥 CompanyId <= 2 veya SCADA homepage bulunamadıysa normal URL aç
                    const url = `/?companyId=${selectedCompanyId}&user_id=${userId}&username=${encodeURIComponent(username)}&user_email=${encodeURIComponent(userEmail)}&user_companyId=${userCompanyId}&token=${encodeURIComponent(jwtToken || '')}`;
                    console.log("✅ TesisSec: Opening new tab with auth in URL:", url);
                    window.open(url, "_blank");

                    // 🔥 Ana sekmede state'i sıfırla, böylece kullanıcı tekrar tesis seçebilir
                    setTimeout(() => {
                      Set_active_companies([]);
                      Set_tesisSec(true);
                      setSelectedOptionTesis("Tesis Seçin");
                      setIsOpenTesis(false);
                    }, 500);
                  }}
                >
                  {item.companyName}
                </button>
              })}
            </div>

          </div>}


        </div>
      </section>
    </div>
  );
}

export default TesisSec
